export const firebaseConfigProd = {
apiKey: "AIzaSyDWm10pRxz27c1gt8AMtM1q11m5AwjTJPc",
  authDomain: "experiences.80days.co.jp",
  projectId: "eighty-days-exp-prod",
  storageBucket: "eighty-days-exp-prod.firebasestorage.app",
  messagingSenderId: "717772456716",
  appId: "1:717772456716:web:7ffbc1f8b802bb7163ff29",
  measurementId: "G-4XE3KSVEGR"
};
